import React from 'react'
import { ArticlesCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import ArticlesCategoriesContainer from './ArticlesCategoriesContainer'

const ArticlesCategories = ({ location, match }) => (
  <ArticlesCategoriesLoader>
    <ArticlesCategoriesContainer location={location} match={match} />
  </ArticlesCategoriesLoader>
)

ArticlesCategories.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
}

export default ArticlesCategories
